import { render, staticRenderFns } from "./FooterTimeline.vue?vue&type=template&id=2728183a&"
import script from "./FooterTimeline.vue?vue&type=script&lang=js&"
export * from "./FooterTimeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports